import { useEffect } from 'react';

import { useStatsigClient } from '@coursera-web/statsig';

import {
  ORG_SCOPED_HOME_OVERRIDE_ORG_IDS,
  ORG_SCOPED_HOME_STATSIG_GATE,
} from 'bundles/unified-common/constants/orgScopedHomeStatsig';

/**
 * Checks if a specific organization is opted into org-scoped home.
 *
 * Unlike useIsOrgScopedHome (which reads from page-level context),
 * this hook checks a given org ID directly. Used in the program switcher
 * to determine per-org link behavior.
 *
 * Pre-rollout: returns true only when the org is in the hardcoded override set.
 *
 * TODO(HOME-5213): On rollout day, add back the `enableOrgScopedHome` product feature check
 * so all opted-in orgs are included: `isEnabled = isOverrideOrg || featureEnabled`.
 */
export function useIsOrgOptedIntoOrgScopedHome(orgId: string): boolean {
  const { checkGate } = useStatsigClient();

  const isEnabled = !!orgId && ORG_SCOPED_HOME_OVERRIDE_ORG_IDS.has(orgId);

  useEffect(() => {
    if (isEnabled) {
      checkGate(ORG_SCOPED_HOME_STATSIG_GATE);
    }
  }, [isEnabled, checkGate]);

  return isEnabled;
}
